(() => {
  if (window.GigantiLeads) return;
  const completedForms = new WeakSet();
  const formTypes = new Set(['contact', 'product_inquiry', 'sell_trade']);

  window.GigantiLeads = Object.freeze({
    confirm(form, body, formType) {
      const id = body?.conversation?.id;
      if (!Number.isSafeInteger(id) || id <= 0 || !formTypes.has(formType)) return false;
      if (completedForms.has(form)) return true;
      completedForms.add(form);
      document.dispatchEvent(new CustomEvent('giganti:lead-accepted', {
        detail: Object.freeze({ form_type: formType }),
      }));
      return true;
    },
  });
})();
